import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col items-center p-5 bg-gray-50" }
const _hoisted_2 = { class: "mt-10 mb-16 sm:mt-8 sm:mb-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "font-inter text-2xl sm:text-3xl text-secondary50 leading-tight text-center mb-10 max-w-lg" }, [
  /*#__PURE__*/_createTextVNode(" Crie a conta da sua "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "empresa"),
  /*#__PURE__*/_createTextVNode(" para começar. ")
], -1)
const _hoisted_4 = { class: "flex flex-col sm:flex-row justify-center items-center gap-8 w-full max-w-4xl px-4" }
const _hoisted_5 = { class: "card p-6 flex flex-col items-center text-center bg-white rounded-lg shadow-md w-full sm:w-72 h-60" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold text-lg text-gray-800 mb-2" }, "Empresa", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600 mb-6 flex-grow" }, " Gerenciamento de equipes, protocolos, escalas de plantão e controle financeiro ", -1)
const _hoisted_8 = {
  class: "mt-10 p-4 bg-[#FEF9E7] border border-[#F1C21B] rounded flex flex-col items-center gap-3 max-w-lg",
  "data-testid": "signup-doctor-app-notice"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "font-inter text-sm text-textPrimary text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "É médico(a)?"),
  /*#__PURE__*/_createTextVNode(" Baixe o aplicativo Minha Escala para se cadastrar. ")
], -1)
const _hoisted_10 = { class: "my-12 w-full max-w-sm" }

import Logo from '@/components/designSystem/Logo/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import AppStoreBadges from '@/components/designSystem/AppStoreBadges/index.vue'
import PATHS from '@/router/paths'

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createVNode(Logo, {
            width: "160px",
            logo: "full"
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createVNode(_component_router_link, {
          to: _unref(PATHS).SIGNUPCOMPANY,
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(OutlineButton, {
              text: "Selecionar",
              width: "100%",
              "data-testid": "signup-company-select-button"
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(AppStoreBadges)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(GhostButton, {
        text: "Voltar para o Login",
        width: "auto",
        to: "/",
        "data-testid": "signup-back-login-button"
      })
    ])
  ]))
}
}

})